import { render, staticRenderFns } from "./StaticCardFA.vue?vue&type=template&id=cd140a48"
import script from "./StaticCardFA.vue?vue&type=script&lang=js"
export * from "./StaticCardFA.vue?vue&type=script&lang=js"
import style0 from "./StaticCardFA.vue?vue&type=style&index=0&id=cd140a48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports